import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {withStyles} from 'material-ui/styles';
import Paper from 'material-ui/Paper';
import Table, {TableBody, TableCell, TableHead, TableRow} from 'material-ui/Table';
import Button from 'material-ui/Button';
import AddIcon from 'material-ui-icons/Add';
import AdminListToolbar from '../../common/list-toolbar/index';
import AdminFileItem from '../item/index';
import DeleteDialog from '../../common/delete-dialog';

const styles = theme => ({
	root: {
		margin: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 24}px`
	},
	createButton: {
		position: 'fixed',
		bottom: theme.spacing.unit * 6,
		right: theme.spacing.unit * 6
	}
});

const AdminFileList = props => {
	const {
		classes,
		items,
		parentId,
		handleEditItem,
		handleDeleteItem,
		handleConfirmDelete,
		handleCancelDelete,
		deleteTarget,
		deleteConfirmation
	} = props;

	return (
		<div className={classes.root}>
			<AdminListToolbar title="Files"/>
			<div className={classes.createButton}>
				<Button
					fab
					color="primary"
					aria-label="Create"
					className={classes.button}
					component={Link}
					to={`/admin/collections/${parentId}/files/create`}
				>
					<AddIcon/>
				</Button>
			</div>
			<Paper>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell padding="checkbox">
								&nbsp;
							</TableCell>
							<TableCell padding="none">
								Title
							</TableCell>
							<TableCell padding="default">
								Type
							</TableCell>
							<TableCell padding="dense">
								Preview
							</TableCell>
							<TableCell padding="dense">
								Last updated
							</TableCell>
							<TableCell padding="none">
								&nbsp;
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{items.sort((a, b) => a.sortOrder - b.sortOrder)
							.map((item, index) => (
								<AdminFileItem
									key={index}
									item={item}
									parentId={parentId}
									onEdit={handleEditItem}
									onDelete={handleDeleteItem}
								/>
							))
						}
					</TableBody>
				</Table>
			</Paper>
			<DeleteDialog
				open={deleteConfirmation}
				deleteTarget={deleteTarget}
				handleCancel={handleCancelDelete}
				handleConfirm={handleConfirmDelete}
			/>
		</div>
	);
};

AdminFileList.propTypes = {
	classes: PropTypes.object.isRequired,
	items: PropTypes.array.isRequired,
	parentId: PropTypes.string.isRequired,
	handleEditItem: PropTypes.func.isRequired,
	handleDeleteItem: PropTypes.func.isRequired,
	handleConfirmDelete: PropTypes.func.isRequired,
	handleCancelDelete: PropTypes.func.isRequired,
	deleteConfirmation: PropTypes.bool.isRequired,
	deleteTarget: PropTypes.object
};

export default withStyles(styles)(AdminFileList);



// WEBPACK FOOTER //
// ./src/client/components/admin/files/list/list.jsx